import React from 'react'
import MyTest from '../Components/MyTest/MyTest'

const MyTestView = () => {
  return (
    <div>

        <MyTest />

    </div>
  )
}

export default MyTestView